module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('PageInfo', [(_vm.hasContent) ? _c('InfoDescription', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  })]) : _vm._e(), _vm._l((_vm.blocks), function(ref, index) {
    var icon = ref.icon;
    var title = ref.title;
    var text = ref.text;

    return [(text) ? _c('InfoBlock', {
      key: index,
      attrs: {
        "icon": icon,
        "title": title
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(text)
      }
    })]) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e49d1cb","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/activities/card/info/component.vue
// module id = 461bb497bc8e5a3524cb
// module chunks = 35